import { backend } from '@api';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { shallow } from 'zustand/shallow';
import { useAuth } from '@/state/auth';
import PageLoad from '../page-load';

const FetchingMe = () => {
  const navigate = useNavigate();
  const { logout, meReceived } = useAuth(
    state => ({
      logout: state.logout,
      meReceived: state.meReceived,
    }),
    shallow,
  );
  useEffect(() => {
    backend.meGet().then(response => {
      if (response.status === 200) {
        meReceived(response.data);
      } else {
        logout();
        navigate('/login');
      }
    });
  }, []);

  return <PageLoad />;
};

export default FetchingMe;
